import { render, staticRenderFns } from "./DocumentoTipo.vue?vue&type=template&id=3891d548"
import script from "./DocumentoTipo.vue?vue&type=script&lang=js"
export * from "./DocumentoTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports